<template>
    <div>
        <slot v-if='webShareSupported' name="default" v-bind:share="share"/>
        <slot name="alt" v-else v-bind:share="share"/>
    </div>
</template>

<script>
export default {
  name: 'WebShare',
  props: {
    url: {
      type: String,
      required: true,
    },
    text: {
      type: String,
    },
    title: {
      type: String,
      required: true,
    },
    alternativeAction: {
      type: Function,
    },
  },
  data() {
    return {
      webShareSupported: false,
    };
  },
  created() {
    this.webShareSupported = (navigator && navigator.share) !== undefined;
  },
  methods: {
    async mainShare() {
      try {
        this.$emit('share-started');
        await navigator.share({
          url: this.url,
          title: this.title,
          text: this.text,
        });
        this.$emit('share-done');
      } catch (error) {
        if (['AbortError', 'NotAllowedError'].includes(error.name)) {
          this.$emit('share-aborted');
        } else {
          this.$emit('share-failed', { error: error.message });
        }
      }
    },
    async alternativeShare() {
      this.$emit('share-started', { alternative: true });
      await this.alternativeAction(this.url, this.text, this.title);
      this.$emit('share-done', { alternative: true });
    },
    async share() {
      if (this.webShareSupported) {
        await this.mainShare();
      } else {
        await this.alternativeShare();
      }
    },
  },
};
</script>
